module.exports = __webpack_public_path__ + "media/images/user-4b4824f6b05ba521b827a99561a84592.svg";